module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65 bg-white"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("戻る")])])]), _c('body', {
    staticClass: "treatment__detail-container"
  }, [(_vm.$route.params.pass == 'post_allowance') ? _c('div', [_vm._m(0), _vm._m(1)]) : _vm._e(), (_vm.$route.params.pass == 'extra_allowance') ? _c('div', [_vm._m(2), _vm._m(3)]) : _vm._e(), (_vm.$route.params.pass == 'adjustment_allowance') ? _c('div', [_vm._m(4), _vm._m(5)]) : _vm._e(), (_vm.$route.params.pass == 'housing_allowance') ? _c('div', [_vm._m(6), _vm._m(7)]) : _vm._e(), (_vm.$route.params.pass == 'commuting_allowance') ? _c('div', [_vm._m(8), _vm._m(9)]) : _vm._e(), (_vm.$route.params.pass == 'support_allowance') ? _c('div', [_vm._m(10), _vm._m(11)]) : _vm._e(), (_vm.$route.params.pass == 'assignment_allowance') ? _c('div', [_vm._m(12), _vm._m(13)]) : _vm._e(), (_vm.$route.params.pass == 'moving_allowance') ? _c('div', [_vm._m(14), _vm._m(15)]) : _vm._e(), (_vm.$route.params.pass == 'homecoming_allowance') ? _c('div', [_vm._m(16), _vm._m(17)]) : _vm._e(), (_vm.$route.params.pass == 'rental_housing_assistance') ? _c('div', [_vm._m(18), _vm._m(19)]) : _vm._e(), (_vm.$route.params.pass == 'other_expence') ? _c('div', [_vm._m(20), _vm._m(21)]) : _vm._e(), (_vm.$route.params.pass == 'congratulatory_condolence_money') ? _c('div', [_vm._m(22), _vm._m(23)]) : _vm._e(), (_vm.$route.params.pass == 'sick_childcare_allowance') ? _c('div', [_vm._m(24), _vm._m(25)]) : _vm._e(), (_vm.$route.params.pass == 'flu_vaccination') ? _c('div', [_vm._m(26), _vm._m(27)]) : _vm._e(), (_vm.$route.params.pass == 'paid_holidays') ? _c('div', [_vm._m(28), _vm._m(29)]) : _vm._e(), (_vm.$route.params.pass == 'sick_childcare_leave') ? _c('div', [_vm._m(30), _vm._m(31)]) : _vm._e(), (_vm.$route.params.pass == 'childcare_leave') ? _c('div', [_vm._m(32), _vm._m(33)]) : _vm._e(), (_vm.$route.params.pass == 'maternity_leave') ? _c('div', [_vm._m(34), _vm._m(35)]) : _vm._e(), (_vm.$route.params.pass == 'short_time_work_for_childcare') ? _c('div', [_vm._m(36), _vm._m(37)]) : _vm._e(), (_vm.$route.params.pass == 'menstrual_leave') ? _c('div', [_vm._m(38), _vm._m(39)]) : _vm._e(), (_vm.$route.params.pass == 'nursing_care_leave') ? _c('div', [_vm._m(40), _vm._m(41)]) : _vm._e(), (_vm.$route.params.pass == 'short_time_work_for_nursing_care') ? _c('div', [_vm._m(42), _vm._m(43)]) : _vm._e(), (_vm.$route.params.pass == 'domitory') ? _c('div', [_vm._m(44), _vm._m(45)]) : _vm._e(), (_vm.$route.params.pass == 'jump') ? _c('div', [_vm._m(46), _vm._m(47)]) : _vm._e(), (_vm.$route.params.pass == 'step_up_system') ? _c('div', [_vm._m(48), _vm._m(49)]) : _vm._e(), (_vm.$route.params.pass == 'wonder_ college') ? _c('div', [_vm._m(50), _vm._m(51)]) : _vm._e(), (_vm.$route.params.pass == 'ESmycard') ? _c('div', [_vm._m(52), _vm._m(53)]) : _vm._e(), (_vm.$route.params.pass == 'syaraku') ? _c('div', [_vm._m(54), _vm._m(55)]) : _vm._e(), (_vm.$route.params.pass == 'proposal_system') ? _c('div', [_vm._m(56), _vm._m(57)]) : _vm._e(), (_vm.$route.params.pass == 'referral_system') ? _c('div', [_vm._m(58), _vm._m(59)]) : _vm._e(), (_vm.$route.params.pass == 'wonder_award') ? _c('div', [_vm._m(60), _vm._m(61)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("役職手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("役職に昇格すると支給される手当で、責務や役割などに対して支給されます。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("割増手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("前払い分の残業代として、法定時間外労働（15時間分）と深夜労働（50時間分）を合算して支給されます。実際に残業が短時間であった場合も支給されます。また、実勤務時間の法定時間外労働と深夜労働の割増賃金を合算して、割増手当を超過した場合には『精算割増手当』として別途支給されます。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("調整手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("定期昇給として業務経験に応じた給与として、支給致します。（5年上限）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("住宅手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("正社員は、業務上の必要性においては、転居を伴う転勤を命じることがあります。職場近隣に住居を貸与された場合、その家賃の一部を補助されます。（単身者上限20,000円、扶養者あり上限30,000円）※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("通勤手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("通勤に要する費用の一部を補助されます。※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("応援手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("正社員は、業務上の必要性においては、自宅から通勤できない応援勤務を命じられ、応援店舗での入寮し勤務する場合、一定期間の生活雑貨、備品購入等の補助として支給されます。（月10,000円：上限3か月）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("赴任手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("正社員は、業務上の必要性においては、転勤を命じることがあります。その際、転居を伴う転勤が発生した際、移動先店舗までの移動に掛かる交通費を会社が負担します。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("引越手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("正社員は、転居を伴う「転勤」が発生した際、転居に要する引越費用を会社が負担します。（上限150,000円）※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("帰省旅費手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("業務上の必要性においては、転居を要する転勤を命じられた際、妻子と別居となった場合、妻子のもとへ帰省する際の交通費を会社が負担します。（月1回上限）※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("賃貸住宅補助")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("正社員は、住宅手当受給者が、転居を要する転勤を命じられた際、赴任先の近隣へ契約当事者として住宅を賃貸した場合、敷金・礼金・紹介手数料の一部を会社が負担します。（単身者上限：100,000円）※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("その他費用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("正社員は、業務上の必要性においては、転居を要する転勤を命じられた際、子供を養育している方が転勤を理由に転校を要した場合、転校先で着用が義務づけられているものを購入した際に支給されます。（上限20,000円）※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("慶弔見舞金")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("当社に1年以上在籍する従業員（パート含む）の結婚、出産または親族の死亡があった際に慶弔金を支給致します。※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("病児保育補助手当")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("子供を扶養している方が、子供の病気が原因で出勤できない状況となった際、病児保育施設へ預けて出勤する際の病児保育費用の一部を補助致します。（1児童当たり上限2,000円/回）※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("インフル予防接種")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("11月～2月の期間に就労する従業員は、インフルエンザの予防接種費用の半額を会社が負担致します。（1回/シーズン）※要申請")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("有給休暇")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("労働基準法に定められた労働者の休日となります。翌月分のシフト作成を行う前までに申し出ることで、休日を取得できます。ただし、繁忙日が予想される日等は避けてください。年10日以上付与される方は、年5日消化していただきます※要請求")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("看護休暇")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("小学校就学前の子供の病気やけが等の看病をするために取得できる休暇です。※無給")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("育児休業")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("従業員が1歳に満たない子を養育する場合、申し出を行うと休業が取得できます。※無給")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("産前産後休暇")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("女性従業員が、子を出産する際、出産予定日前42日より出産後56日の期間、申し出ることで休暇が取得できます。※無給")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("育児短時間勤務")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("3歳に満たない子供がいる従業員が育児時間を確保するため、勤務時間を6時間（休憩除く）とし、負担を軽くすることが出来ます。※遅刻・早退等による給与控除あり。※無給")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("生理休暇")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("生理日の就業が著しく困難な女性従業員が取得できる休暇です。※無給")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("介護休業")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("対象家族の介護を要し、休業が必要となった場合、申し出を行うと休業が取得できます。（上限通算93日/名）※無給")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("介護短時間勤務")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("要介護状態にある対象家族を介護のため、勤務時間を短く選択する勤務が選択できます。※遅刻・早退等による給与控除あり。※無給")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("社員寮")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("正社員は、業務上の必要性においては、転勤を命じることがあります。そのため、完全個室のワンルームタイプの社員寮を準備しております。（単身者のみ）家賃・光熱費全額会社負担。※生活必需品や消耗品等はお自身でご準備ください。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("JUMP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("従業員のスキルアップに役立つ資格を取得するための検定費用やセミナー受講費用の一部を会社が負担します。※要条件あり、店舗長確認")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("ステップアップ制度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("ワンダーランドの昇進システムは、自分自身の成長に合わせて自己申告により昇進を目指していただきます。常に目標を描いて上位職責を目指していただく制度となっています。受講される際には、心の準備、提出書類の準備は、役職者の第一歩となりますので、事前確認をお願いします。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("ワンダーカレッジ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("ワンダーランドびとの成長を後押しするための支援として、会社が選定した講座を当社で働く方であれば無料で受講できます。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("ESmyカード")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("日々の仕事の中で仲間を褒めたたえ、感謝の気持ちを素直に伝え合うメッセージカードです。褒めたたえ合う行動を形に残すことで、自分自身とその周囲への仕事の質、モチベーション、人間関係の向上が図れます。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("sya楽")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("社楽(しゃらく)TRC制度は、社員交流をはじめとした仲間との一体感を創出し、業務中ではわからない仲間の新たな一面（リーダーシップ、フォロワーシップ等）を発見することで、コミュニケーションの促進につなげ、店舗における活力つながるレクリエーション活動です。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("社内提案制度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("お客様にもっと快適に遊技を楽しんで頂きたい！そんな思いから、もっとこうしたら「いいね！」を現場の従業員から提案してもらう制度です。WONDERWORLDからの提案をお待ちしています。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("友達紹介制度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("友達や知り合いを紹介し、その紹介によって入社し、不安を抱える新入社員を一定期間サポートし、試用期間である有期契約期間から更新採用された場合には、紹介した側と紹介された側に報酬お祝い金が支給される制度です。※詳細は友達紹介ご確認ください。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-title"
  }, [_c('h1', [_vm._v("ワンダー栄誉賞")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__detail-text"
  }, [_c('p', [_vm._v("日ごろのワンダーランドびとの素晴らしい行動を褒めたたえ、その中から会社の模範となる行動に関して社内表彰により、全社員で表彰致します。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68277edc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/treatment-detail.pug
// module id = 1426
// module chunks = 1